import {block, unblock} from './block-ui';

if (typeof appConfig.isMaster !== 'undefined' && appConfig.isMaster) {
    import('../pages/desktop/ideas');
}

$(document).ready(function () {
    const tabs = {
        '#tabs-top': '/index/tab-top/',
        '#tabs-discount': '/index/tab-discounts/',
        '#tabs-souvenirs': '/index/tab-souvenirs/',
        '#ideas': '/index/tab-ideas/',
    };

    const loadedTabs = {};

    for (let key in tabs) {
        const value = tabs[key];

        $('[href="' + key + '"]').click(function (ev) {
            ev.preventDefault();

            if (loadedTabs[key]) {
                return;
            }

            block();

            $.get(value + '?locale='+ window.appConfig.locale, response => {
                loadedTabs[key] = true;

                $(key).append(response);

                unblock();
            });
        });
    }
});
